import Controller from '../abstracts/Controller';

export default class PdpController extends Controller {
  static get COMPONENTS() {
    return [
        'NotifyMeComponent',
        'NotifyMeBtnComponent',
        'PdpFixedBarComponent',
        'PdpZoomComponent',
        'AddToBagBtnComponent',
        'SizeGuideLayerComponent',
      	'SizeTableSwitcherComponent',
        'SizeRowComponent',
        'PdpEditorialComponent',
        'FidelityComponent'
    ];
  }
}
